// apiService.js
import axios from 'axios';

class ApiService {
  constructor() {
    this.apiKey = 'c7cc7779-b3b2-427d-a695-fbc0a47f580a';
    this.baseUrl = 'https://asia-southeast1-newswav-marketplace.cloudfunctions.net'; // Replace with your actual base URL
  }

  // Method to save an order
  async saveOrder({ name, email, contactNumber, snapshot, remarks }) {
    const url = `${this.baseUrl}/createOrder`;

    try {
      const response = await this.post(url, {
        headers: this._getHeaders(),
        body: {
          name,
          email,
          contactNumber,
          snapshot,
          remarks
        },
      });

      if (response.status === 404) {
        throw new Error(response.data);
      }

      if (response.status !== 200) {
        console.error(`API call failed at: ${url}`);
        throw new Error(response.data);
      }

      console.log(`SUCCESS: ${url}, Response:`, response.data);
      return true;
    } catch (error) {
      console.error('Error:', error);
      return false;
    }
  }

  // Generic POST method
  async post(endpoint, { headers = {}, body = {}, timeout = 10000 }) {
    try {
      const response = await axios.post(endpoint, body, {
        headers: { ...this._getHeaders(), ...headers },
        timeout,
      });
      return response;
    } catch (error) {
      console.error(`API call failed at: ${endpoint}, error:`, error);
      this._handleError(error);
      throw error;
    }
  }

  // Handle API errors
  _handleError(error) {
    if (error.response) {
      throw new Error(error.response.data?.respMsg || 'An unexpected error has occurred.');
    } else {
      console.error('Error sending request:', error.message);
    }
  }

  // Generate headers
  _getHeaders() {
    return {
      'apiKey': this.apiKey,
      'Content-Type': 'application/json',
    };
  }
}

export default new ApiService();
